/* REACT HOT LOADER */ if (module.hot) { (function () { var ReactHotAPI = require("/mnt/xvdb/jenkins/workspace/ProFrontend-Mamobility-Device/node_modules/react-hot-api/modules/index.js"), RootInstanceProvider = require("/mnt/xvdb/jenkins/workspace/ProFrontend-Mamobility-Device/node_modules/react-hot-loader/RootInstanceProvider.js"), ReactMount = require("react-dom/lib/ReactMount"), React = require("react"); module.makeHot = module.hot.data ? module.hot.data.makeHot : ReactHotAPI(function () { return RootInstanceProvider.getRootInstances(ReactMount); }, React); })(); } try { (function () {

'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _style2 = require('antd/lib/button/style');

var _button = require('antd/lib/button');

var _button2 = _interopRequireDefault(_button);

var _jsx2 = require('babel-runtime/helpers/jsx');

var _jsx3 = _interopRequireDefault(_jsx2);

var _assign = require('babel-runtime/core-js/object/assign');

var _assign2 = _interopRequireDefault(_assign);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _immutable = require('immutable');

var _echartsForReact = require('echarts-for-react');

var _echartsForReact2 = _interopRequireDefault(_echartsForReact);

var _tpl = require('tpl');

var _tpl2 = _interopRequireDefault(_tpl);

var _tool = require('util/tool');

var _config = require('util/config');

var _comps = require('comps');

require('./index.less');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _ref = (0, _jsx3.default)('p', {}, void 0, '\u4ECA\u65E5\u6CE8\u518C');

var _ref2 = (0, _jsx3.default)('p', {}, void 0, '\u6628\u65E5\u6CE8\u518C');

var _ref3 = (0, _jsx3.default)('p', {}, void 0, '\u7D2F\u8BA1\u6CE8\u518C');

var _ref4 = (0, _jsx3.default)('p', {}, void 0, '\u5728\u7EBF\u8BBE\u5907');

var _ref5 = (0, _jsx3.default)('p', {}, void 0, '\u4ECA\u65E5\u7ED1\u5B9A');

var _ref6 = (0, _jsx3.default)('p', {}, void 0, '\u6628\u65E5\u7ED1\u5B9A');

var _ref7 = (0, _jsx3.default)('p', {}, void 0, '\u7D2F\u8BA1\u7ED1\u5B9A');

var _ref8 = (0, _jsx3.default)('p', {}, void 0, '\u79BB\u7EBF\u8BBE\u5907');

var Main = function (_Component) {
  (0, _inherits3.default)(Main, _Component);

  function Main(props, context) {
    (0, _classCallCheck3.default)(this, Main);

    var _this = (0, _possibleConstructorReturn3.default)(this, (Main.__proto__ || (0, _getPrototypeOf2.default)(Main)).call(this, props, context));

    _this.state = {
      productTemplate: null,
      baseInfo: {
        name: '',
        factoryName: '',
        productId: '',
        accessType: '',
        networkType: '',
        operatingSystem: '',
        createTime: '',
        registerNumber: ''
      },
      deviceInfo: {
        todayRegisterDeviceCount: '',
        yesterdayRegisterDeviceCount: '',
        totalRegisterDeviceCount: '',
        onlineDeviceCount: '',
        todayActiveDeviceCount: '',
        yesterdayActiveDeviceCount: '',
        totalActiveDeviceCount: '',
        offlineDeviceCount: ''
      },
      timeStatus: 1,
      beginTime: '2017/07/01',
      endTime: '2017/07/10',
      option: {
        tooltip: {
          trigger: 'axis'
        },
        legend: {
          data: ['总设备数量', '新增设备数量']
        },
        grid: {
          left: '3%',
          right: '4%',
          bottom: '3%',
          containLabel: true
        },
        toolbox: {
          feature: {
            saveAsImage: {}
          }
        },
        xAxis: {
          type: 'category',
          boundaryGap: false,
          data: [],
          axisLine: {
            show: false
          },
          axisTick: {
            show: false
          }
        },
        yAxis: {
          type: 'value',
          axisLine: {
            show: false
          },
          axisTick: {
            show: false
          }
        },
        series: [{
          name: '总设备数量',
          type: 'line',
          data: [120, 132, 101, 134, 90, 230, 210],
          itemStyle: {
            normal: {
              color: '#4CA9D4'
            }
          }
        }, {
          name: '新增设备数量',
          type: 'line',
          data: [220, 182, 191, 234, 290, 330, 310],
          itemStyle: {
            normal: {
              color: '#5867C3'
            }
          }
        }]
      }
    };
    return _this;
  }

  (0, _createClass3.default)(Main, [{
    key: 'getProductTemplate',
    value: function getProductTemplate() {
      var _this2 = this;

      var params = this.props.params;

      (0, _tool.http)(_config.apiJson.getProductDetail, { productId: params.id }).then(function (res) {
        _this2.setState({
          productTemplate: res.productTemplate
        });
      });
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      // const {params} = this.props;
      // let options = {productId:params.id};
      // http(apiJson.getProductStatistics,options).then(res=>{
      //   res.accessType = filter.accessType(res.accessType);
      //   res.operatingSystem = filter.operatingSystem(res.operatingSystem);
      //   res.networkType = filter.operatingSystem(res.networkType);
      //   res.createTime = tool.formatTime(new Date(res.createTime));
      //   res.pictureUrl =`${target}${res.pictureUrl}`;
      //   this.setState({
      //     baseInfo:res
      //   })
      // })
      //获取 模板标识符 来决定渲染什么样的模板
      this.getProductTemplate();
      this.chartsHandle();
      // }
      console.log(this.state.baseInfo, this.state.deviceInfo, '------------------');
    }
  }, {
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate(nextProps, nextState) {
      return !(0, _immutable.is)((0, _immutable.fromJS)(this.props), (0, _immutable.fromJS)(nextProps)) || !(0, _immutable.is)((0, _immutable.fromJS)(this.state), (0, _immutable.fromJS)(nextState));
    }
  }, {
    key: 'copyText',
    value: function copyText(text) {
      _tool.copy.handle(text);
    }
  }, {
    key: 'mixCallBack',
    value: function mixCallBack(arg) {
      var option = {
        startTime: arg[0].replace(/\//g, '-') + ' 00:00:00',
        endTime: arg[1].replace(/\//g, '-') + ' 00:00:00'
      };
      this.chartsHandle(option);
      // console.log("mixCallBack",arg);
    }
  }, {
    key: 'editRouter',
    value: function editRouter(id) {
      this.props.router.push({
        pathname: this.state.productTemplate === 2 ? '/equipment/' + id : '/edit/' + id
      });
    }
  }, {
    key: 'deviceRouter',
    value: function deviceRouter(id) {
      this.props.router.push({
        pathname: '/device/index/' + id
      });
    }
  }, {
    key: 'chartsHandle',
    value: function chartsHandle() {
      var _this3 = this;

      var arg = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var params = this.props.params;

      var options = (0, _assign2.default)({ productId: params.id }, arg);
      (0, _tool.http)(_config.apiJson.getProduct, options).then(function (res) {
        // 基本数据
        var baseInfo = {};
        baseInfo.name = res.name;
        baseInfo.factoryName = res.factoryName;
        baseInfo.registerNumber = res.registerNumber;
        baseInfo.accessType = _tool.filter.accessType(res.accessType);
        baseInfo.operatingSystem = _tool.filter.operatingSystem(res.operatingSystem);
        baseInfo.networkType = _tool.filter.networkType(res.networkType);
        baseInfo.createTime = _tool.tool.formatTime(new Date(res.createTime.replace(/\-/g, '/')));
        baseInfo.pictureUrl = '' + _config.target + res.pictureUrl;
        baseInfo.productId = res.id;
        _this3.setState({
          baseInfo: baseInfo
        });
      });
      (0, _tool.http)(_config.apiJson.getProductStatistics, options).then(function (res) {
        _this3.setState({
          //option: Object.assign(this.state.option, time, data),
          deviceInfo: res
        });
      });
    }
  }, {
    key: 'formate',
    value: function formate(date) {
      var month = date.getMonth() + 1;
      var day = date.getDate();
      return month + '/' + day;
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          routes = _props.routes,
          params = _props.params,
          children = _props.children,
          route = _props.route;
      var _state = this.state,
          option = _state.option,
          baseInfo = _state.baseInfo,
          deviceInfo = _state.deviceInfo;

      var role = window.localStorage.getItem('userName');
      return (0, _jsx3.default)('div', {
        className: 'product-detail'
      }, void 0, (0, _jsx3.default)('div', {
        className: 'info'
      }, void 0, (0, _jsx3.default)('div', {
        className: 'info-top'
      }, void 0, (0, _jsx3.default)('div', {
        className: 'info-top-cont'
      }, void 0, (0, _jsx3.default)('div', {
        className: 'cont-img'
      }, void 0, (0, _jsx3.default)('img', {
        src: baseInfo.pictureUrl,
        alt: ''
      })), (0, _jsx3.default)('div', {
        className: 'cont-text'
      }, void 0, (0, _jsx3.default)('p', {}, void 0, baseInfo.name), (0, _jsx3.default)('p', {}, void 0, '\u521B\u5EFA\u65F6\u95F4\uFF1A', baseInfo.createTime))), role == '立马专属账号' ? '' : (0, _jsx3.default)(_button2.default, {
        type: 'primary',
        className: 'info-top-btn',
        onClick: this.editRouter.bind(this, baseInfo.productId)
      }, void 0, '\u7F16\u8F91'))), (0, _jsx3.default)('div', {
        className: 'device'
      }, void 0, (0, _jsx3.default)('div', {
        className: 'device-text'
      }, void 0, (0, _jsx3.default)('div', {}, void 0, _ref, (0, _jsx3.default)('p', {}, void 0, deviceInfo.todayRegisterDeviceCount ? deviceInfo.todayRegisterDeviceCount : 0)), (0, _jsx3.default)('div', {}, void 0, _ref2, (0, _jsx3.default)('p', {}, void 0, deviceInfo.yesterdayRegisterDeviceCount ? deviceInfo.yesterdayRegisterDeviceCount : 0)), (0, _jsx3.default)('div', {}, void 0, _ref3, (0, _jsx3.default)('p', {}, void 0, deviceInfo.totalRegisterDeviceCount ? deviceInfo.totalRegisterDeviceCount : 0)), (0, _jsx3.default)('div', {}, void 0, _ref4, (0, _jsx3.default)('p', {}, void 0, deviceInfo.onlineDeviceCount ? deviceInfo.onlineDeviceCount : 0))), (0, _jsx3.default)('div', {
        className: 'device-text'
      }, void 0, (0, _jsx3.default)('div', {}, void 0, _ref5, (0, _jsx3.default)('p', {}, void 0, deviceInfo.todayActiveDeviceCount ? deviceInfo.todayActiveDeviceCount : 0)), (0, _jsx3.default)('div', {}, void 0, _ref6, (0, _jsx3.default)('p', {}, void 0, deviceInfo.yesterdayActiveDeviceCount ? deviceInfo.yesterdayActiveDeviceCount : 0)), (0, _jsx3.default)('div', {}, void 0, _ref7, (0, _jsx3.default)('p', {}, void 0, deviceInfo.totalActiveDeviceCount ? deviceInfo.totalActiveDeviceCount : 0)), (0, _jsx3.default)('div', {}, void 0, _ref8, (0, _jsx3.default)('p', {}, void 0, deviceInfo.offlineDeviceCount ? deviceInfo.offlineDeviceCount : 0)))));
    }
  }]);
  return Main;
}(_react.Component);

exports.default = (0, _tpl2.default)({
  id: 'productDetail', // 应用关联使用的redux
  component: Main // 接收数据的组件入口
});

/* REACT HOT LOADER */ }).call(this); } finally { if (module.hot) { (function () { var foundReactClasses = module.hot.data && module.hot.data.foundReactClasses || false; if (module.exports && module.makeHot) { var makeExportsHot = require("/mnt/xvdb/jenkins/workspace/ProFrontend-Mamobility-Device/node_modules/react-hot-loader/makeExportsHot.js"); if (makeExportsHot(module, require("react"))) { foundReactClasses = true; } var shouldAcceptModule = true && foundReactClasses; if (shouldAcceptModule) { module.hot.accept(function (err) { if (err) { console.error("Cannot apply hot update to " + "index.jsx" + ": " + err.message); } }); } } module.hot.dispose(function (data) { data.makeHot = module.makeHot; data.foundReactClasses = foundReactClasses; }); })(); } }


//////////////////
// WEBPACK FOOTER
// ./src/containers/product/detail/index.jsx
// module id = 1060
// module chunks = 0